"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react")); // tslint:disable: max-line-length


var emanIcomPaths = react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
  id: "design",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, react_1.default.createElement("g", {
  id: "login",
  transform: "translate(-690.000000, -384.000000)",
  fill: "#0092E0"
}, react_1.default.createElement("g", {
  id: "Group-4",
  transform: "translate(480.000000, 303.000000)"
}, react_1.default.createElement("g", {
  id: "Group-3",
  transform: "translate(150.000000, 80.000000)"
}, react_1.default.createElement("g", {
  id: "eMan_logo",
  transform: "translate(60.000000, 0.000000)"
}, react_1.default.createElement("path", {
  d: "M19.1104621,10.1956102 C16.9785934,10.1956102 15.2439469,8.32939755 15.2439469,6.03512852 C15.2439469,3.74121268 16.9785934,1.875 19.1104621,1.875 L43.4102858,1.875 C45.5424828,1.875 47.2771293,3.74121268 47.2771293,6.03512852 C47.2771293,8.32939755 45.5424828,10.1956102 43.4102858,10.1956102 L19.1104621,10.1956102 Z M7.56578447,21.8732697 C5.46174167,21.8732697 3.75,20.1758176 3.75,18.0893394 C3.75,16.00254 5.46174167,14.3050879 7.56578447,14.3050879 L17.433891,14.3050879 C19.5382577,14.3050879 21.25,16.00254 21.25,18.0893394 C21.25,20.1758176 19.5382577,21.8732697 17.433891,21.8732697 L7.56578447,21.8732697 Z M21.25,42.0549259 C21.25,44.1417253 19.5382577,45.8391774 17.433891,45.8391774 L7.56578447,45.8391774 C5.46174167,45.8391774 3.75,44.1417253 3.75,42.0549259 C3.75,39.9684476 5.46174167,38.2709956 7.56578447,38.2709956 L17.433891,38.2709956 C19.5382577,38.2709956 21.25,39.9684476 21.25,42.0549259 Z M60,30.7010497 L60,30.7032973 L60,30.7055448 C60,32.7899976 58.2370506,34.4869065 56.0700642,34.4869065 L3.92993577,34.4869065 C1.76294937,34.4869065 0,32.7899976 0,30.7055448 L0,30.7032973 L0,30.7010497 C0,28.6153126 1.76294937,26.9187248 3.92993577,26.9187248 L56.0700642,26.9187248 C58.2370506,26.9187248 60,28.6153126 60,30.7010497 Z M43.5768063,50.8846343 C45.7400757,50.8846343 47.5,52.5826958 47.5,54.6695284 C47.5,56.755397 45.7400757,58.452816 43.5768063,58.452816 L18.9228619,58.452816 C16.7599255,58.452816 15,56.755397 15,54.6695284 C15,52.5826958 16.7599255,50.8846343 18.9228619,50.8846343 L43.5768063,50.8846343 Z M38.7499988,18.0891788 C38.7499988,16.0022908 40.4617722,14.3050879 42.56553,14.3050879 L52.4338191,14.3050879 C54.5379009,14.3050879 56.2499988,16.0022908 56.2499988,18.0891788 C56.2499988,20.1760669 54.5379009,21.8732697 52.4338191,21.8732697 L42.56553,21.8732697 C40.4617722,21.8732697 38.7499988,20.1760669 38.7499988,18.0891788 Z",
  id: "logo"
}))))))); // tslint:enable: max-line-length

exports.default = emanIcomPaths;